import React, { useEffect, useMemo } from 'react';
import { AnalyticsSection } from '../../../Analytics/components/Layout/AnalyticsSection';
import { usePreprocessedParams } from '../../hooks/usePreprocessedParams';
import { ReportsPreprocessedContent } from './ReportsPreprocessedContent';
import { Alert } from 'antd';
import ReportsPreprocessedInputForm from './ReportsPreprocessedInputForm';
import { IBestDataset } from '../../../../../types/analytics';

interface ReportsProps {
  coordinates: number[];
  defaultDataset?: any;
  datasets: IBestDataset[];
}

export default function ReportsPreprocessed(props: ReportsProps) {
  const { defaultDataset, coordinates, datasets } = props;

  const {
    datasetSW,
    datasetHD,
    datasetWind,
    dataSW,
    dataHD,
    dataWind,
    isLoadingSW,
    isLoadingHD,
    isLoadingWind,
    errorSW,
    errorHD,
    errorWind,
    signalRErrorMessage,
    handleDatasetChange,
    showSignalRError,
  } = usePreprocessedParams({
    coordinates: coordinates,
    defaultDataset: defaultDataset,
  });

  const plotInputContent = useMemo(
    () => (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        <ReportsPreprocessedInputForm
          datasetHD={datasetHD}
          datasetSW={datasetSW}
          datasetWind={datasetWind}
          onSelectDataset={handleDatasetChange}
          datasets={datasets}
          isLoadingDatasetHD={isLoadingHD}
          isLoadingDatasetSW={isLoadingSW}
          isLoadingDatasetWind={isLoadingWind}
        />
      </div>
    ),
    [datasetSW, datasetHD, datasetWind, isLoadingHD, isLoadingWind, isLoadingSW]
  );

  const updateContent = useMemo(
    () => (
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '36px',
        }}
      >
        <></>
      </div>
    ),
    []
  );

  const reportsContent = useMemo(() => {
    return (
      <>
        {showSignalRError && signalRErrorMessage && (
          <Alert description={signalRErrorMessage} type='error' closable />
        )}
        <ReportsPreprocessedContent
          dataSW={dataSW}
          dataHD={dataHD}
          dataWind={dataWind}
          isLoadingSW={isLoadingSW}
          isLoadingHD={isLoadingHD}
          isLoadingWind={isLoadingWind}
          errorHD={errorHD}
          errorSW={errorSW}
          errorWind={errorWind}
        />
      </>
    );
  }, [
    dataHD,
    dataSW,
    dataWind,
    isLoadingHD,
    isLoadingSW,
    isLoadingWind,
    errorHD,
    errorSW,
    errorWind,
    signalRErrorMessage,
    showSignalRError,
  ]);

  return (
    <AnalyticsSection
      plotInputContent={plotInputContent}
      updateContent={updateContent}
      chartContent={reportsContent}
      isLoading={isLoadingSW || isLoadingHD || isLoadingWind}
    />
  );
}
